<script setup>
import AssessmentNavigationStep from '../AssessmentNavigationStep/AssessmentNavigationStep.vue'
// import ConfettiExplosion from 'vue-confetti-explosion'

const props = defineProps({
  catalog: {
    type: Object,
    default: undefined,
  },
  currentCategory: {
    type: Object,
    default: undefined,
  },
  currentStep: {
    type: String,
    default: undefined,
  },
  allowRating: {
    type: Boolean,
    default: false,
  },
  allowReview: {
    type: Boolean,
    default: false,
  },
  menuExpanded: {
    type: Boolean,
    default: false,
  },
})

const steps = [
  {
    value: 'welcome',
    label: 'Einleitung',
  },
  {
    value: 'evaluation',
    label: 'Ersteinschätzung',
  },
  {
    value: 'rating',
    label: 'Bewertung',
  },
  {
    value: 'review',
    label: 'Auswertung',
  },
]

const isStepDisabled = function (step) {
  if (step == 'rating' && !props.allowRating) return true
  if (step == 'review' && !props.allowReview) return true
  return false
}

const emit = defineEmits(['selectCategoryById', 'openStep'])
</script>

<template>
  <nav
    id="main-menu"
    class="AssessmentNavigation"
    :class="{ 'AssessmentNavigation--expanded': menuExpanded }"
    aria-label="Assessment-Fortschritt"
  >
    <ol class="AssessmentNavigation-steps">
      <!-- <ConfettiExplosion :particle-count="200" /> -->
      <AssessmentNavigationStep
        v-for="step in steps"
        :key="step.value"
        :value="step.value"
        :label="step.label"
        :current-step="props.currentStep"
        :current-category="props.currentCategory"
        :catalog="props.catalog"
        :disabled="isStepDisabled(step.value)"
        :has-subnavigation="
          props.currentStep != 'review' && props.currentStep != 'welcome'
        "
        @select-category-by-id="emit('selectCategoryById', $event)"
        @open-step="emit('openStep', $event)"
      />
    </ol>
  </nav>
</template>
